export default __webpack_public_path__ + "locales/uk-UA/Settings.json?hash=a011ed5ccade84638a660427adc524c7";